import React from "react";
import { makeStyles } from "@mui/styles";
import { DrawerFormElement, FormControlLabel, RaiseColors, Typography } from "componentLibrary";
import { Checkbox } from "client/componentLibrary";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var useStyles = makeStyles(function () {
  return {
    toggle: {
      position: "absolute",
      right: 0,
      top: 0
    },
    toggleLabel: {
      margin: 0
    },
    checkbox: {
      border: "none",
      padding: "0px"
    },
    labelText: {
      marginRight: "8px"
    }
  };
});
var ToggleableDrawerFormElement = function ToggleableDrawerFormElement(_ref) {
  var title = _ref.title,
    children = _ref.children,
    appendIcon = _ref.appendIcon,
    _ref$toggleLabel = _ref.toggleLabel,
    toggleLabel = _ref$toggleLabel === void 0 ? "" : _ref$toggleLabel,
    onToggleVisibility = _ref.onToggleVisibility,
    isVisible = _ref.isVisible,
    labelStyle = _ref.labelStyle,
    disableCheckbox = _ref.disableCheckbox;
  var classes = useStyles();
  var toggleButton = /*#__PURE__*/_jsx("div", {
    className: classes.toggle,
    children: /*#__PURE__*/_jsx(FormControlLabel, {
      control: /*#__PURE__*/_jsx(Checkbox, {
        fontSize: 20,
        checked: isVisible,
        onChange: onToggleVisibility,
        classes: {
          root: classes.checkbox
        },
        color: "secondary",
        disabled: disableCheckbox
      }),
      label: /*#__PURE__*/_jsx(Typography, {
        variant: "paragraph_xsmall",
        weight: "medium",
        style: labelStyle,
        className: classes.labelText,
        color: RaiseColors.glacier2400,
        noWrap: true,
        children: toggleLabel
      }),
      classes: {
        root: classes.toggleLabel
      },
      labelPlacement: "start"
    })
  });
  return /*#__PURE__*/_jsx(DrawerFormElement, {
    title: title,
    appendIcon: /*#__PURE__*/_jsxs(_Fragment, {
      children: [appendIcon, toggleButton]
    }),
    children: children
  });
};
export default ToggleableDrawerFormElement;